import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Locator32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      d="M15.997 3.25c4.552 0 8.253 3.726 8.253 8.303 0 3.088-3.323 9.247-7.624 15.856l-.629.966-.629-.966C11.083 20.825 7.75 14.642 7.75 11.553c0-4.576 3.7-8.303 8.247-8.303zm0 1.5c-3.716 0-6.747 3.053-6.747 6.803 0 2.507 2.99 8.183 6.747 14.063 3.77-5.899 6.753-11.556 6.753-14.063 0-3.751-3.032-6.803-6.753-6.803zM16 7.85c2.126 0 3.838 1.785 3.838 3.97 0 2.185-1.712 3.97-3.838 3.97-2.126 0-3.838-1.785-3.838-3.97 0-2.185 1.712-3.97 3.838-3.97zm0 1.5c-1.284 0-2.338 1.1-2.338 2.47s1.054 2.47 2.338 2.47 2.338-1.1 2.338-2.47S17.284 9.35 16 9.35z"
      fillRule="nonzero"
    />
  </svg>
);

export default Locator32;
